module.exports = "https://static.cdns.space/qurangrowth-temp/img/p4.02044a6e.webp";